"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../../core/utils");
var _selectors = require("../../exception/selectors");
var _default = exports["default"] = function _default(state, errorCallback, internalErrorUri) {
  var exception = (0, _selectors.getException)(state);
  if (exception) {
    _utils.console.consoleError(exception);
    errorCallback(internalErrorUri);
    return true;
  }
  return false;
};